import { useState } from 'react';
import { getString } from '../../../../helpers/styles';
import icons from '../../../../shared/assets/icons/redesign';

const { Check } = icons;

export default function CommunityFilterGroupPopupContent({
  onClose,
  filteredGroupTypes,
  setFilteredGroupTypes,
  allGroupTypes
}) {
  const [selectedGroupTypes, setSelectedGroupTypes] =
    useState(filteredGroupTypes);

  return (
    <>
      <div className="communityGroupList-popup-header">
        <h4 className="communityGroupList-popup-header-title">Filter op:</h4>

        <button className="popup-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <ul className="communityGroupList-popup-list">
        {[...allGroupTypes].map((type, idx) => (
          <li
            key={idx}
            onClick={() => setSelectedGroupTypes(type)}
            className={getString([
              {
                value: 'communityGroupList-popup-list-item cursor-pointer',
                condition: true
              },
              {
                value: 'communityGroupList-popup-list-item-active',
                condition: selectedGroupTypes === type
              }
            ])}
          >
            {type}{' '}
            <span className="communityGroupList-popup-item-check-wrap">
              <Check className="communityGroupList-popup-item-check" />
            </span>
          </li>
        ))}
      </ul>

      <div className="communityGroupList-popup-btn-wrap">
        <button
          onClick={() => (onClose(), setFilteredGroupTypes(selectedGroupTypes))}
          className="communityGroupList-popup-btn cursor-pointer popup-button-primary"
        >
          Sorteer
        </button>
      </div>
    </>
  );
}
